import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/text.svg';

export const IconText = createIconComponent(Icon);
